import { IInventoryEntity, IInventoryExtendedEntity, ILocationsEntity, IProductEntity } from '@phrospr/lib-models';
import { IInventoryState } from '@/store/inventory/inventory.state';

export const inventoryMutations = {
    resetInventory(state: IInventoryState) {
        state.upsertInventory = undefined;
    },

    createNewInventory: function (state: IInventoryState) {
        state.upsertInventory = {
            inventory_id: null,
            location_id: null,
            product_id: null,
            quantity_on_hand: null,
            data: null,
        };
    },

    updateInventory(state: IInventoryState, inventory: IInventoryExtendedEntity) {
        state.upsertInventory = inventory;
    },

    cacheInventory(state: IInventoryState, inventoryUpsert: IInventoryEntity) {
        state.upsertInventory = inventoryUpsert;
    },

    setRestoreCache(state: IInventoryState) {
        state.isCachedUpsertInventory = true;
    },

    setSelectedProduct(state: IInventoryState, selectedProduct: IProductEntity) {
        state.selectedProduct = selectedProduct;
    },

    setSelectedLocation(state: IInventoryState, selectedLocation: ILocationsEntity) {
        state.selectedLocation = selectedLocation;
    },
    removeCacheInventory(state: IInventoryState) {
        state.isCachedUpsertInventory = undefined;
    },
};
